import type { AdminUserDetail } from '../types';

export function OverviewTab({ user }: { user: AdminUserDetail }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Field label="ID" value={user.id} />
      <Field label="Email" value={user.email} />
      <Field label="Phone" value={user.phone ?? '—'} />
      <Field label="Country" value={user.country ?? '—'} />
      <Field label="Timezone" value={user.timezone ?? '—'} />
      <Field label="Provider" value={user.provider ?? '—'} />
      <Field label="Plan expires" value={user.planExpiresAt ?? '—'} />
      <Field label="Last active" value={user.lastActiveAt ?? '—'} />
      <Field label="Firebase UID" value={user.firebaseUid ?? '—'} />
      <Field label="Total invitations" value={String(user.invitationsCount)} />
      <Field label="Revenue" value={`₹${(user.revenue / 100).toFixed(2)}`} />
      <Field label="Created" value={user.createdAt} />
    </div>
  );
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className="glass-panel rounded-xl p-3">
      <div className="text-[10px] uppercase tracking-widest font-bold text-on-surface-variant">{label}</div>
      <div className="text-sm break-all">{value}</div>
    </div>
  );
}
